import React from 'react';
import { Modal, Box, Typography, Button, CircularProgress } from '@mui/material';

const SendReceiptModal = ({ open, onClose, onSend, loading }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          color: '#000000', // Force black text
        }}
      >
        <Typography variant="h6" id="modal-title" sx={{ color: '#000000' }}>
          Send Receipts
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, color: '#000000' }}>
          Invoices have been marked as paid. Would you like to send receipts to the clients now?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <Button
            variant="contained"
            onClick={onClose}
            color="secondary"
          >
            Skip
          </Button>
          <Button
            variant="contained"
            onClick={onSend}
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Send Receipts'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SendReceiptModal;